var map = {
  "./homepage.nested.json": "24849",
  "./teams.nested.json": "84863",
  "./portal.nested.json": "77335",
  "./translation.nested.json": "13536"
};
function webpackAsyncContext(req) {
  return Promise.resolve().then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }

    var id = map[req];
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6421;
module.exports = webpackAsyncContext;
